import { useNavigate } from "react-router-dom";
import { PATH_DASHBOARD } from "config";
import { CheckoutStatusPanel } from "../CheckoutStatusPanel";

type OtpPurchasePendingResultProps = {
  /** True when polling exhausted without a verified license (not a hard failure). */
  timedOut?: boolean;
};

export const OtpPurchasePendingResult: React.FC<OtpPurchasePendingResultProps> = ({
  timedOut = false,
}) => {
  const navigate = useNavigate();

  return (
    <CheckoutStatusPanel
      variant="pending"
      title={timedOut ? "Still confirming your purchase" : "Confirming your purchase"}
      description={
        timedOut
          ? "Payment went through, but your license isn’t active yet. Check Billing in a moment, or go home. We’ll keep working in the background."
          : "Payment received. We’re activating your license. This usually takes a few seconds."
      }
      primaryAction={{
        label: "Go to Billing",
        onClick: () => navigate(PATH_DASHBOARD.billing),
      }}
      secondaryAction={{
        label: "Go to Home",
        onClick: () => navigate(PATH_DASHBOARD.home),
      }}
    />
  );
};
